import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  cloneElement,
} from "react";
import {
  BUTTON_TYPES,
  COLORS,
} from "../../../../Diathrive/src/utils/Constants";
import styles from "./styles";
import Text from "../../../../Diathrive/src/components/elements/Text";
import Popup from "../../../../Diathrive/src/components/elements/Popup";
import Button from "../../../../Diathrive/src/components/elements/Button";
import { useNavigate } from "react-router-dom";
import { SETTINGS_TILES } from "../../utils/Constants";
import MyProfile from "./MyProfile";
import { fetchApi } from "../../../../Diathrive/src/utils/ApiHelper";
import { loadingPauseContext } from "../../../../Diathrive/src/contexts/LoadingPauseContext";
import { errorStatusContext } from "../../../../Diathrive/src/contexts/ErrorStatusContext";
import {
  HTTP_METHODS,
  VIEW_DETAILS,
} from "../../../../Diathrive/src/utils/URLConstants";
import UserAvatar from "../../../../Diathrive/src/components/elements/UserAvatar";
import { tID } from "../../../../Diathrive/src/utils/TestIdHelper";
import Divider from "../../../../Diathrive/src/components/elements/Divider";
import { useOutletContext } from "../../../../Diathrive/src/utils/mockedWebLibs/react-router-dom";
import MyBloodSugarRange from "./MyBloodSugarRange";
import MyContactsWeb from "./MyContactsWeb";
import { LogoutIcon } from "../../../../Diathrive/src/utils/SvgIcons";
import { View } from "react-native";
import { shopContext } from "../../../../Diathrive/src/contexts/ShopContext";
import { removeAllLocalData } from "../../../../Diathrive/src/utils/HelperMethods";

const Settings = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [openContacts, setOpenContacts] = useState(false);
  const [openMyBSR, setOpenMyBSR] = useState(false);
  const [openConnectedDevices, setOpenConnectedDevices] = useState(false);
  const [profile, setProfile] = useState();

  const lpc = useContext(loadingPauseContext);
  const esc = useContext(errorStatusContext);
  const ShopC = useContext(shopContext);

  const { setHeaderName, openMyProfile, setOpenMyProfile } = useOutletContext();

  useLayoutEffect(() => {
    if (setHeaderName) setHeaderName("Settings");
  }, [setHeaderName]);

  useEffect(() => {
    getProfile();
    if (openMyProfile) openEditProfile();
  }, [openMyProfile]);

  function openEditProfile() {
    window.scrollTo(0, 0);
    setOpenMyProfile(true);
  }

  const getProfile = () => {
    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.GET, VIEW_DETAILS)
      .then((res) => res.data)
      .then((response) => {
        lpc.setVisible(false);
        const profile = response.data.data;
        setProfile(profile);
      })
      .catch((error) => {
        lpc.setVisible(false);
        esc.showError(error);
      });
  };

  function openMyBloodSugarRange() {
    window.scrollTo(0, 0);
    setOpenMyBSR(true);
  }

  function openMyContacts() {
    window.scrollTo(0, 0);
    setOpenContacts(true);
  }

  const tileClick = (id) => {
    switch (id) {
      case 1:
        openEditProfile();
        break;
      case 3:
        navigate("/my-addresses");
        break;
      case 4:
        openMyBloodSugarRange();
        break;
      case 5:
        openMyContacts();
        break;
      case 6:
        setOpenConnectedDevices(true);
        break;

      default:
        break;
    }
  };

  return (
    <div data-testid={tID("Settings-div-Main")} style={styles.container}>
      <div
        data-testid={tID("Settings-div-TilesContainer")}
        style={styles.settingsContainer}
      >
        {SETTINGS_TILES.map((tile, index) => (
          <div
            data-testid={tID(`Settings-div-TileContainer${index + 1}`)}
            key={tile.id}
            style={styles.containerItem}
            onClick={() => tileClick(tile.id)}
          >
            <div
              data-testid={tID(`Settings-div-TileInside${index + 1}`)}
              style={styles.itemInsideLayout}
            >
              {tile.id === 1 ? (
                <UserAvatar
                  name={profile?.firstName + " " + profile?.lastName}
                  size={40}
                  source={profile?.signedImageUrl}
                  radius={20}
                  onPress={() => tileClick(tile.id)}
                />
              ) : (
                <View style={styles.iconBg}>
                  {cloneElement(tile.icon, {
                    testID: tID(`Settings-img-TileIcon${index + 1}`),
                  })}
                </View>
              )}
              <div style={styles.itemText}>
                <Text
                  testID={tID(`Settings-Text-Header${index + 1}`)}
                  variation="Subtitle1Bold"
                  color={COLORS.blueDarkText}
                >
                  {tile.header}
                </Text>
                <br />

                <Text
                  testID={tID(`Settings-Text-Description${index + 1}`)}
                  variation="Subtitle2Regular"
                  color={COLORS.grey2}
                >
                  {tile.description}
                </Text>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Divider style={styles.divider} />

      <div
        data-testid={tID("Settings-div-SignoutContainer")}
        style={styles.signout}
        onClick={() => setOpen(true)}
      >
        <LogoutIcon
          testID={tID("Settings-img-SignoutIcon")}
          tintColor={COLORS.grey2}
        />
        <Text
          testID={tID("Settings-Text-SignOut")}
          variation="Body1Regular"
          color={COLORS.grey2}
        >
          Sign-out
        </Text>
      </div>

      <Popup
        testID={tID("Settings-PopUp-SignOut")}
        visible={open}
        title={"Sign Out"}
        onRequestClose={() => setOpen(false)}
        description={
          <Text color={COLORS.grey2} variation="Body1SemiBold">
            Are you sure you want to sign out from your Diathrive Health
            account?
          </Text>
        }
        modalViewStyle={styles.modelViewStyles}
      >
        <Button
          testID={tID("Settings-Button-Cancel")}
          style={styles.cancelButton}
          onPress={() => setOpen(false)}
          title={"Cancel"}
        />
        <Button
          testID={tID("Settings-Button-SignOut")}
          style={styles.signOutButton}
          title={"Sign Out"}
          onPress={async () => {
            await removeAllLocalData(ShopC);
            navigate("/login");
          }}
          buttonType={BUTTON_TYPES.Filled}
          titleColor={COLORS.white}
        />
      </Popup>
      <MyProfile />
      <MyBloodSugarRange openMyBSR={openMyBSR} setOpenMyBSR={setOpenMyBSR} />
      <MyContactsWeb
        openContacts={openContacts}
        setOpenContacts={setOpenContacts}
      />
    </div>
  );
};

export default Settings;
